export default __webpack_public_path__ + "static/media/commentBackBg.dad09826.svg";